import React from 'react';
import { Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';

export const AboutSection = () => {
  return (
    <section 
      id="about"
      className="section-padding"
      style={{ background: 'var(--brand-pale-sage)' }}
    >
      <div className="container-custom">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            {/* Image */}
            <motion.div
              className="order-2 lg:order-1"
              initial={{ opacity: 0, scale: 1.04 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="premium-image-container max-w-[480px] mx-auto">
                <img
                  src="https://customer-assets.emergentagent.com/job_c7ce965f-b752-41cd-938a-aad5b5cd43c6/artifacts/1scuwz83_WhatsApp%20Image%202026-02-21%20at%201.01.35%20PM.jpeg"
                  alt="Tanmayee Nookala"
                  className="w-full h-auto object-cover"
                />
              </div>
            </motion.div>

            {/* Content */}
            <Reveal className="order-1 lg:order-2">
              <span className="eyebrow">Meet Your Expert</span>
              <h2 className="heading-1 mb-3">Tanmayee Nookala</h2>
              <p 
                className="text-lg font-medium mb-2"
                style={{ color: 'var(--brand-periwinkle)' }}
              >
                Founder & Chief Nutritionist
              </p>
              <p 
                className="body-small mb-6"
                style={{ color: 'var(--brand-muted-grey)' }}
              >
                M.Sc. (Nutritional Sciences) | B.Sc. (Home Science - Nutrition)
              </p>

              <div 
                className="h-1 w-20 mb-8"
                style={{ background: 'var(--brand-periwinkle)' }}
              />

              <p className="body-regular leading-relaxed mb-8">
                Tanmayee Nookala is a Clinical and Lifestyle Nutritionist with a Masters in Nutritional Sciences from Symbiosis University, Pune and a Bachelors in Home Science (with Nutrition specialisation). She has supported 200+ clients through structured, evidence-based programs and now leads the nutrition philosophy at Arogya Vitalis, focused on clarity, consistency, and sustainable health. Having lived across North and South India, Tanmayee brings strong cultural understanding to her nutrition practice, with familiarity across regional cuisines and food habits. Fluent in English, Hindi, Marathi and Telugu, she designs plans that feel familiar, practical, and easy to sustain in everyday Indian households.
              </p>

              <div className="flex items-center gap-4">
                <div 
                  className="px-6 py-3"
                  style={{ 
                    background: 'white',
                    border: '1px solid var(--brand-periwinkle)',
                    borderRadius: '12px'
                  }}
                >
                  <p className="text-sm font-semibold" style={{ color: 'var(--brand-deep-plum)' }}>
                    200+ clients guided
                  </p>
                </div>
                <a
                  href="https://www.linkedin.com/in/tanmayee-nookala/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 transition-smooth hover:opacity-80"
                  style={{ 
                    background: 'var(--brand-periwinkle)',
                    borderRadius: '12px'
                  }}
                  aria-label="LinkedIn Profile"
                >
                  <Linkedin size={20} color="white" />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
